import React, { useState, useEffect } from "react";
import {
  Table,
  Button,
  Modal,
  Input,
  Space,
} from "antd";
import {
  PlusOutlined,
  EditOutlined,
  DeleteOutlined,
  SearchOutlined,
} from "@ant-design/icons";
import axios from "axios";

import {
  CreateFeeMaster,
  GetFeeMaster,
  UpdateFeeMaster,
} from "../../../AllAPI/AdminAPI";
import { toast } from "react-toastify";

const FeeMaster = () => {

  const storedBranchId = sessionStorage.getItem("branch_id");
  const BoardingYear = sessionStorage.getItem("BoardingYear");


  const [data, setData] = useState([]);
  const [searchText, setSearchText] = useState("");
  const [loading, setLoading] = useState(false);

  // --- FORM STATES USING useState ---
  const [feeName, setFeeName] = useState("");

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [editingId, setEditingId] = useState(null);

  useEffect(() => {
    fetchFees();
  }, []);


  const fetchFees = async () => {
    setLoading(true);
    try {
      const res = await axios.get(`${GetFeeMaster}/${storedBranchId}/${BoardingYear}`);

      const formatted = res.data.map((item, index) => ({
        key: item.fee_id,
        index: index + 1,
        fee_name: item.fee_name,
      }));

      setData(formatted);
    } catch (err) {
      toast.error("Failed to load fees");
    }finally {
    setLoading(false); // 👉 Stop loader
  }
  };

  // --- OPEN MODAL ---
  const handleOpenModal = (record = null) => {
    if (record) {
      setEditingId(record.key);
      setFeeName(record.fee_name);
    } else {
      setEditingId(null);
      setFeeName("");
    }
    setIsModalOpen(true);
  };

  // --- SAVE OR UPDATE ---
  const handleSave = async () => {
    if (!feeName.trim()) return toast.error("Please enter fee name");

    const payload = {
      fee_name: feeName,
      branch_id: storedBranchId,
      year:BoardingYear
    };

    try {
      if (editingId) {
        const res = await axios.put(`${UpdateFeeMaster}/${editingId}`, payload);
        if (res.data === "UPDATED") {
          toast.success("Fee updated successfully");
        }
        else if (res.data === "EXIST") {
          toast.warn("Already Exist!");
        }
      } else {
        const res = await axios.post(`${CreateFeeMaster}`, payload);
        if (res.data === "SAVED") {
          toast.success("Fee added successfully");
        }
        else if (res.data === "EXIST") {
          toast.warn("Already Exist!");
        }
      }

      fetchFees();
      setIsModalOpen(false);
      setEditingId(null);
      setFeeName("");
    } catch (err) {
      toast.error("Failed to save fee");
    }
  };




  // --- SEARCH ---
  const filteredData = data.filter((item) =>
    ((item.fee_name ?? "") + "").toLowerCase().includes(searchText.toLowerCase())
  );

  const columns = [
    { title: "Sr No", dataIndex: "index" },
    { title: "Fee", dataIndex: "fee_name" },
    {
      title: "Actions",
      align: "center",
      render: (_, record) => (
        <Space>
          <Button
            icon={<EditOutlined />}
            size="small"
            onClick={() => handleOpenModal(record)}
          />
        </Space>
      ),
    },
  ];

  return (
    <div className="form-container mainContainer">

     <div className="row p-0 m-0 pb-5">
        <div className="col-12 col-md-2"></div>
        <div className="col-12 col-md-8">

        <div className="header-row">
          <h2 className="page-title">Fee Master</h2>
        </div>

      <div className="search-bar">
        <Input
          placeholder="Search Fee..."
          prefix={<SearchOutlined />}
          value={searchText}
          onChange={(e) => setSearchText(e.target.value)}
          style={{ width: 250 }}
        />

        <Button
          type="primary"
          className="mt-2 mt-md-0"
          icon={<PlusOutlined />}
          onClick={() => handleOpenModal()}
          style={{ marginLeft: 10 }}
        >
          Add Fee
        </Button>
      </div>

      <Table columns={columns} dataSource={filteredData} pagination={{ pageSize: 10 }} bordered loading={loading} scroll={{ x: 'max-content' }} />


      </div>
        <div className="col-12 col-md-2"></div>
      </div>

      <Modal
        title={editingId ? "Edit Fee" : "Add Fee"}
        open={isModalOpen}
        onCancel={() => setIsModalOpen(false)}
        footer={[
          <Button key="cancel" onClick={() => setIsModalOpen(false)}>
            Cancel
          </Button>,
          <Button key="save" type="primary" onClick={handleSave}>
            Save
          </Button>,
        ]}
      >

        <div>
          <label>Fee Name</label>
          <Input
            value={feeName}
            onChange={(e) => setFeeName(e.target.value)}
            placeholder="Enter fee name"
          />
        </div>
      </Modal>
    </div>
  );
};

export default FeeMaster;
